
import React from 'react';
import { ContactForm } from '../../../components/base/ContactForm';

const ContactSection: React.FC = () => {
  return (
    <section className="py-16 bg-blue-600">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="text-white">
            <h2 className="text-3xl font-bold mb-6">
              Garanta a infraestrutura inteligente que impulsiona a produtividade da sua empresa.
            </h2>
            <p className="text-blue-100 mb-8">
              Fornecendo soluções de TI que permitem que você trabalhe de forma mais inteligente
            </p>
            <a 
              href="https://wa.me/553173565180?text=Olá" 
              className="inline-flex items-center bg-white text-blue-600 font-semibold px-8 py-3 rounded-lg hover:bg-gray-100 transition-colors whitespace-nowrap"
            >
              FALE COM UM ANALISTA
            </a>
          </div>
          <div>
            <ContactForm 
              title="Fale Conosco"
              subtitle="Entre em contato para saber mais sobre nossos serviços"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export { ContactSection };
export default ContactSection;
